module.exports = __webpack_public_path__ + "static/img/29-北京市第十八中学附属实验小学1.b699ab5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/29-北京市第十八中学附属实验小学1.png
// module id = 7fMF
// module chunks = 0